// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.J5E26L8Y4wAvgzMDSlsb{align-items:center;gap:8px;padding-bottom:32px;padding-left:20px;display:flex}.f9uPgUXHE83SeGoq3ler{margin:-8px 20px 16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"info": `J5E26L8Y4wAvgzMDSlsb`,
	"alert": `f9uPgUXHE83SeGoq3ler`
};
export default ___CSS_LOADER_EXPORT___;
